// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionCard-cls1_2qZ","cls2":"SuggestionCard-cls2_RXF SuggestionCard-cls1_2qZ"};